var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 777,
    viewBox: "0 0 745 777",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.6367,
    y: 94.2946,
    width: 51.089,
    height: 15.4158,
    transform: "rotate(70 56.6367 94.2946)",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5938,
    y: 677.112,
    width: 47.1107,
    height: 13.4267,
    transform: "rotate(-71 64.5938 677.112)",
    fill: "#00FFD9",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.414,
    y: 468.252,
    width: 15.2845,
    height: 11.4375,
    transform: "rotate(129 647.414 468.252)",
    fill: "#00FFD9",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.953,
    y: 92.3062,
    width: 59.0455,
    height: 11.4375,
    transform: "rotate(172 730.953 92.3062)",
    fill: "#00FFD9",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6367,
    y: 321.056,
    width: 37.165,
    height: 11.4375,
    transform: "rotate(32 56.6367 321.056)",
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5938,
    y: 589.59,
    width: 41.1433,
    height: 11.4375,
    transform: "rotate(-105 64.5938 589.59)",
    fill: "#00FFD9",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.289,
    y: 792.482,
    width: 53.0781,
    height: 11.4375,
    transform: "rotate(-135 486.289 792.482)",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.547,
    y: 685.069,
    width: 37.165,
    height: 11.4375,
    transform: "rotate(-105 621.547 685.069)",
    fill: "#00FFD9",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.195,
    y: 16.7184,
    width: 61.0347,
    height: 11.4375,
    transform: "rotate(77 504.195 16.7184)",
    fill: "#00FFD9",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.422,
    y: 384.709,
    width: 25.2302,
    height: 7.45926,
    transform: "rotate(178 645.422 384.709)",
    fill: "#00FFD9",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.863,
    y: 659.21,
    width: 53.0781,
    height: 13.4267,
    transform: "rotate(47 563.863 659.21)",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.746,
    y: 243.48,
    width: 33.1868,
    height: 11.4375,
    transform: "rotate(63 219.746 243.48)",
    fill: "#00FFD9",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.324,
    y: 635.34,
    width: 31.1976,
    height: 7.45926,
    transform: "rotate(145 297.324 635.34)",
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.398,
    y: 249.448,
    width: 25.2302,
    height: 9.4484,
    transform: "rotate(161 649.398 249.448)",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.605,
    y: 277.295,
    width: 49.0998,
    height: 7.45926,
    transform: "rotate(95 245.605 277.295)",
    fill: "#00FFD9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701.179,
    cy: 432.507,
    r: 6.02708,
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.541,
    cy: 56.561,
    r: 10.0054,
    fill: "#00FFD9",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.746,
    cy: 114.246,
    r: 6.02708,
    fill: "#00FFD9",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 737.975,
    cy: 359.904,
    r: 7.02165,
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.901,
    cy: 446.432,
    r: 4.03795,
    fill: "#00FFD9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.8489,
    cy: 7.82695,
    r: 5.03252,
    fill: "#00FFD9",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6195,
    cy: 94.355,
    r: 11.9945,
    fill: "#00FFD9",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5646,
    cy: 403.665,
    r: 7.02165,
    fill: "#00FFD9",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.25,
    cy: 586.665,
    r: 10.9999,
    fill: "#00FFD9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.477 466.794L106.167 485.395L87.5664 475.084L97.8767 456.484L116.477 466.794Z",
    fill: "#00FFD9",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.173 60.5277L345.346 59.0713L357.021 41.7623L366.173 60.5277Z",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.713 209.699L139.033 212.195L133.031 206.791L134.71 198.891L142.391 196.396L148.392 201.8L146.713 209.699Z",
    fill: "#00FFD9",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.096 22.5841L491.701 21.4695L496.038 31.2106L488.114 38.3456L478.879 33.0141L481.096 22.5841Z",
    fill: "#00FFD9",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.843 148.056L119.165 155.529L111.692 170.851L96.3698 163.378L103.843 148.056Z",
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.051 750.834L413.843 740.501L419.687 729.958L431.739 729.748L437.947 740.08L432.103 750.623L420.051 750.834Z",
    fill: "#00FFD9",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.542 661.726L128.175 659.498L130.403 672.131L117.77 674.358L115.542 661.726Z",
    fill: "#00FFD9",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.141 49.3038L306.014 34.5946L317.19 24.5323L331.491 29.1792L334.618 43.8885L323.443 53.9508L309.141 49.3038Z",
    fill: "#00FFD9",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.499 653.563L274.763 643.756L284.388 640.813L291.749 647.678L289.485 657.485L279.86 660.428L272.499 653.563Z",
    fill: "#00FFD9",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.233 527.849L254.379 505.468L272.188 519.383L251.233 527.849Z",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.066 761.461L591.719 770.222L582.957 772.57L576.544 766.156L578.891 757.395L587.653 755.047L594.066 761.461Z",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.343 355.945L430.806 343.683L443.657 341.418L452.044 351.413L447.582 363.675L434.731 365.941L426.343 355.945Z",
    fill: "#00FFD9",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.385 110.936L272.385 102.542L280.778 120.542L262.778 128.935L254.385 110.936Z",
    fill: "#00FFD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1257 117.167L62.6789 132.615L47.2309 130.168L49.6776 114.72L65.1257 117.167Z",
    fill: "#00FFD9",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.357 440.068L279.606 421.752L297.922 424.001L295.673 442.317L277.357 440.068Z",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.235 376.768L510.54 374.185L518.035 388.895L506.362 400.568L491.652 393.073L494.235 376.768Z",
    fill: "#00FFD9",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.71 670.768L19.4772 658.475L29.8605 650.651L40.5106 658.108L36.7094 670.542L23.71 670.768Z",
    fill: "#00FFD9",
    fillOpacity: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.97db222a9d5c2a0ba0a4934a87dd9e7a.svg";
export { ForwardRef as ReactComponent };